import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SilverLake.module.css";
import GameTemplate from "../games/GameTemplate";
import MagicalSymbolSequence from "../games/MagicalSequenceGame";
import GameWrapper from "../GameWrapper";
const SilverLake = () => {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  return (
    <GameWrapper backgroundImage="/SilverLake.webp">
      <button
        onClick={() => handleButtonClick("/home")}
        className={`${styles.homeButton} ${styles.button}`}
      >
        Home
      </button>

      <button
        onClick={() => handleButtonClick("/map")}
        className={`${styles.mapButton} ${styles.button}`}
      >
        Map
      </button>

      <MagicalSymbolSequence />
    </GameWrapper>
  );
};

export default SilverLake;
